export default {
  categories: {
    shoes: 'Calçados',
    hoodies: 'Moletons / Suéteres',
    tshirts: 'Camisetas',
    jackets: 'Jaquetas',
    pants: 'Calças / Shorts',
    headwear: 'Chapéus e bonés',
    sets: 'Conjuntos',
    underwear: 'Roupa íntima',
    jersey: 'Camisas esportivas',
    accessories: 'Acessórios',
    bags: 'Bolsas',
    belts: 'Cintos',
    perfumes: 'Perfumes',
    other: 'Outros itens',
  },
};